import { useEffect, useRef, useContext } from 'react'
import useWebSocket from 'react-use-websocket'
import { toJS } from 'mobx'
import { nanoid } from 'nanoid'
import config from '../../../../config'
import { BuilderContext } from '../store/store.Builder'
import { observer } from 'mobx-react-lite'
import { useNavigate, useLocation } from 'react-router-dom'

export const WebSocketListener = observer(() => {
  const location = useLocation()
  const currentLocation = location.pathname
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`Websocket render count: ${renderCountRef.current}`)
  })

  const store = useContext(BuilderContext)
  const answersStore = store.AnswersStore

  const idWebsocketRef = useRef(nanoid())
  store.setWebSocketID(idWebsocketRef.current)

  console.log(
    'WebSocket connection URL:',
    `${config.URL_WEBSOCKET_BACKEND}/ws/form/${store.url_code}/`
  )

  const { lastJsonMessage, readyState, sendMessage, connect, disconnect } =
    useWebSocket(`${config.URL_WEBSOCKET_BACKEND}/ws/form/${store.url_code}/`, {
      onOpen: () => {
        console.log('WebSocket Opened!')
        console.log('WebSocket ID:', store.webSocketID)
      },
      onClose: (e) => {
        console.log('WebSocket Closed!', e)
        if (currentLocation === location.pathname) {
          alert('La connexion a été fermée. Veuillez rafraîchir la page.')
        }
      },
      onError: (e) => {
        console.log('WebSocket Error!', e)
        alert(
          "Une erreur s'est produite lors de la connexion. Veuillez rafraîchir la page."
        )
      },
      shouldReconnect: () => true,
    })

  useEffect(() => {
    if (lastJsonMessage) {
      let message
      if (
        typeof lastJsonMessage === 'string' &&
        lastJsonMessage.startsWith('{')
      ) {
        try {
          message = JSON.parse(lastJsonMessage)
        } catch (error) {
          console.error('Error parsing message:', error)
        }
      } else {
        message = lastJsonMessage
      }
      // console.log('message de websocket', message)

      if (message && message.type === 'collaborator_update') {
        const parsedText = JSON.parse(message.text)

        // if (
        //   parsedText.websocketID &&
        //   parsedText.websocketID !== store.webSocketID
        // ) {
        // } else {
        try {
          console.log('websocketID:', parsedText.websocketID)
          if (parsedText.action === 'add') {
            store.addCollaborator(parsedText.collaborator)
          } else if (parsedText.action === 'remove') {
            store.removeCollaborator(parsedText.collaborator.id)
          } else if (parsedText.action === 'update') {
            store.updateCollaborator(parsedText.collaborator)
          }
        } catch (error) {
          console.error('Error parsing message:', error)
        }
      } else if (message && message.type === 'RestrictedSubmissions_update') {
        const parsedText = JSON.parse(message.text)
        try {
          console.log('websocketID:', parsedText.websocketID)
          console.log('RestrictedSubmissions_update:', parsedText)
          if (parsedText.action === 'add') {
            store.addRestrictedSubmissions(parsedText.collaborator)
          } else if (parsedText.action === 'remove') {
            console.log('RestrictedSubmissions_update REMOVE:', parsedText)
            store.removeRestrictedSubmissions(parsedText.collaborator.id)
          } else if (parsedText.action === 'update') {
            store.updateRestrictedSubmissions(parsedText.collaborator)
          }
        } catch (error) {
          console.error('Error parsing message:', error)
        }
      } else if (message && message.type === 'EmailNotificationsGroup_update') {
        const parsedText = JSON.parse(message.text)
        try {
          console.log('websocketID:', parsedText.websocketID)
          console.log('EmailNotificationsGroup_update:', parsedText)
          if (parsedText.action === 'add') {
            store.addEmailNotificationsGroup(parsedText.collaborator)
          } else if (parsedText.action === 'remove') {
            console.log('RestrictedSubmissions_update REMOVE:', parsedText)
            store.removeEmailNotificationsGroup(parsedText.collaborator.id)
          } else if (parsedText.action === 'update') {
            store.updateEmailNotificationsGroup(parsedText.collaborator)
          }
        } catch (error) {
          console.error('Error parsing message:', error)
        }
      } else if (message && message.type === 'field_update') {
        const parsedText = JSON.parse(message.text)

        if (
          parsedText.websocketID &&
          parsedText.websocketID !== store.webSocketID
        ) {
          if (parsedText.action === 'update') {
            console.log(
              'mise a jour par websocket',
              store.webSocketID,
              parsedText.websocketID
            )
            store.initialiseFieldsWebSocket(parsedText.fields)
          }
        } else {
        }
        console.log(parsedText)
      } else if (message && message.type === 'form_update') {
        const parsedText = JSON.parse(message.text)

        if (
          parsedText.websocketID &&
          parsedText.websocketID !== store.webSocketID
        ) {
          if (parsedText.action === 'update') {
            console.log('JE MET A JOUR PAR APPEL API')
            store.initialiseFormsWebSocket(parsedText.form)
          }
        } else {
          console.log('JE NE MET A JOUR PAR APPEL API')
        }
        console.log(parsedText)
      } else if (message && message.type === 'answers_update') {
        const parsedText = JSON.parse(message.text)

        {
          if (parsedText.action === 'update') {
            store.initialisationGETCollectFormAnswersData()
            console.log(
              'Je suis dans websocketListener et mon store est ',
              toJS(answersStore.version)
            )
            answersStore.loadData(false)
          }
        }
        console.log('yyyy', parsedText)
      }
    }
  }, [lastJsonMessage])

  return null
})
